export const { REACT_APP_API_URL, REACT_APP_LDH_API_URL } = process.env;
export const API_URL = REACT_APP_API_URL;
export const LDH_API_URL = REACT_APP_LDH_API_URL;
